module.exports = __webpack_public_path__ + "static/EverForward4-5c2013c72f35c167a496d7d7330c41d6.webp";